import React from 'react'
import propTypes from 'prop-types'
import ExternalLink from '../ExternalLink/ExternalLink'
import * as changeCase from 'change-case'
import Divider from '../Divider/Divider'

import './Section.scss'

const Section = ({ children, title, action }) => {
  return (
    <section className='section' id={changeCase.kebabCase(title)}>
      <Divider type='horizontal' thickness={2} />
      <header>
        <h2>{title}</h2>
        {action && <ExternalLink label={action.label} url={action.url} />}
      </header>
      <div className='content'>{children}</div>
    </section>
  )
}

Section.propTypes = {
  children: propTypes.oneOfType([
    propTypes.array,
    propTypes.shape(),
    propTypes.string,
  ]).isRequired,
  title: propTypes.string.isRequired,
  action: propTypes.shape({
    label: propTypes.string,
    url: propTypes.string,
  }),
}

export default Section
